import { defineCustomElement } from '@tyler-components-web/core';
import { CalendarComponent } from './calendar';
export * from './calendar';
export * from './calendar-adapter';
export * from './calendar-constants';
export * from './calendar-foundation';
export * from './core/date-range';
export function defineCalendarComponent() {
    defineCustomElement(CalendarComponent);
}
